import Grid2 from '@shared/components/Grid2';
import { H2 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import Section from '@shared/components/Section';
import { FC, memo } from 'react';

const TrainingInfo: FC = () => (
  <Section>
    <H2>Ablauf des Trainings</H2>

    <Grid2 spacing={{ md: '2rem', xs: '0' }}>
      <Grid2.Item>
        <Paragraph>
          Jede Trainingseinheit bei uns ist einzigartig und variiert von der vorherigen.
        </Paragraph>
        <Paragraph>
          Grundsätzlich beginnen wir jedes Training mit Atem- und Grundübungen. Dann beschäftigen
          wir uns meist mit dem Beladen und Fallen, bevor wir uns speziellen Themen widmen. Zum Ende
          massieren und entspannen wir uns. Den Abschluss bildet eine Gesprächsrunde, in der jeder
          Teilnehmer Feedback geben und Fragen stellen kann.
        </Paragraph>
      </Grid2.Item>
      <Grid2.Item>
        <Paragraph>
          Unsere Gruppen werden nicht nach Anfänger- und Fortgeschrittenen aufgeteilt, noch sonst
          irgendwie. Wir glauben einfach daran, dass jeder von und mit jedem lernen kann. Anfänger
          haben die Chance, schneller Fortschritte zu machen. Fortgeschrittene können ihr Wissen
          durch die Arbeit mit unterschiedlichen Partnern kontinuierlich überprüfen und verbessern.
        </Paragraph>
      </Grid2.Item>
    </Grid2>
  </Section>
);

export default memo(TrainingInfo);
